(function () {
  function parseAnimatedValue(rawText) {
    if (!rawText) return null;

    var text = rawText.trim();
    var match = text.match(/-?\d+(\.\d+)?/);
    if (!match) return null;

    var numericText = match[0];
    var startIndex = match.index || 0;
    var endIndex = startIndex + numericText.length;
    var target = parseFloat(numericText);

    if (!Number.isFinite(target)) return null;

    return {
      prefix: text.slice(0, startIndex),
      suffix: text.slice(endIndex),
      target: target,
      decimals: numericText.includes('.') ? numericText.split('.')[1].length : 0,
    };
  }

  function formatNumber(value, decimals) {
    if (decimals > 0) {
      return value.toFixed(decimals);
    }

    return String(Math.round(value));
  }

  function animateStatValue(element, durationMs) {
    if (!element || element.dataset.counted === 'true') return;

    var parsed = parseAnimatedValue(element.textContent);
    if (!parsed) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      element.dataset.counted = 'true';
      return;
    }

    var start = 0;
    var startTime = null;

    function render(value) {
      element.textContent = parsed.prefix + formatNumber(value, parsed.decimals) + parsed.suffix;
    }

    function tick(timestamp) {
      if (startTime === null) startTime = timestamp;

      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / durationMs, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = start + (parsed.target - start) * eased;

      render(current);

      if (progress < 1) {
        window.requestAnimationFrame(tick);
      } else {
        render(parsed.target);
        element.dataset.counted = 'true';
      }
    }

    render(start);
    window.requestAnimationFrame(tick);
  }

  function initEleventProofCounters(section) {
    if (!section) return;

    var values = section.querySelectorAll('.elevent-proof__stat-value');
    if (!values.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          values.forEach(function (valueEl, index) {
            window.setTimeout(function () {
              animateStatValue(valueEl, 1100);
            }, index * 120);
          });

          observer.disconnect();
        });
      },
      { threshold: 0.35 }
    );

    observer.observe(section);
  }

  function initEleventProofHotspots(section) {
    if (!section) return;

    var hotspots = section.querySelectorAll('.elevent-proof__hotspot');
    if (!hotspots.length) return;

    function closeAllHotspots(except) {
      hotspots.forEach(function (hotspot) {
        if (hotspot === except) return;
        var dot = hotspot.querySelector('.elevent-proof__hotspot-dot');
        var tooltip = hotspot.querySelector('.elevent-proof__hotspot-tooltip');
        if (!dot || !tooltip) return;
        dot.setAttribute('aria-expanded', 'false');
        tooltip.hidden = true;
      });
    }

    hotspots.forEach(function (hotspot) {
      var dot = hotspot.querySelector('.elevent-proof__hotspot-dot');
      var tooltip = hotspot.querySelector('.elevent-proof__hotspot-tooltip');
      if (!dot || !tooltip) return;

      dot.addEventListener('click', function () {
        var isOpen = dot.getAttribute('aria-expanded') === 'true';
        closeAllHotspots(hotspot);
        dot.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        tooltip.hidden = isOpen;
      });
    });

    section.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('.elevent-proof__hotspot')) return;
      closeAllHotspots(null);
    });

    section.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeAllHotspots(null);
    });
  }

  function initEleventInstallVideos(section) {
    if (!section) return;

    var players = section.querySelectorAll('[data-elevent-install-video]');
    if (!players.length) return;

    players.forEach(function (player) {
      var video = player.querySelector('video');
      var playBtn = player.querySelector('[data-elevent-install-video-play]');
      var timeEl = player.querySelector('[data-elevent-install-video-time]');
      var progress = player.querySelector('[data-elevent-install-video-progress]');
      if (!video || !playBtn) return;

      function formatTime(seconds) {
        if (!Number.isFinite(seconds) || seconds < 0) return '00:00';

        var minutes = Math.floor(seconds / 60);
        var secs = Math.floor(seconds % 60);
        return String(minutes).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
      }

      function updateTime() {
        if (!timeEl) return;

        if (video.paused && video.dataset.started !== 'true' && Number.isFinite(video.duration)) {
          timeEl.textContent = formatTime(video.duration);
          return;
        }

        timeEl.textContent = formatTime(video.currentTime);
      }

      function updateProgress() {
        if (!progress || !Number.isFinite(video.duration) || video.duration <= 0) return;
        progress.value = String((video.currentTime / video.duration) * 100);
      }

      function setPlayingState(isPlaying) {
        player.classList.toggle('is-playing', isPlaying);
      }

      playBtn.addEventListener('click', function () {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });

      video.addEventListener('click', function () {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });

      video.addEventListener('play', function () {
        video.dataset.started = 'true';
        setPlayingState(true);
        updateTime();
      });

      video.addEventListener('pause', function () {
        setPlayingState(false);
        updateTime();
      });

      video.addEventListener('loadedmetadata', function () {
        updateTime();
        updateProgress();
      });

      video.addEventListener('timeupdate', function () {
        updateTime();
        updateProgress();
      });

      if (progress) {
        progress.addEventListener('input', function () {
          if (!Number.isFinite(video.duration) || video.duration <= 0) return;
          video.currentTime = (parseFloat(progress.value, 10) / 100) * video.duration;
          updateTime();
        });
      }

      video.addEventListener('ended', function () {
        delete video.dataset.started;
        setPlayingState(false);
        video.currentTime = 0;
        updateTime();
        updateProgress();
      });
    });
  }

  function initEleventAlignmentStage(section) {
    if (!section) return;

    var stages = section.querySelectorAll('[data-elevent-alignment-stage]');
    if (!stages.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    stages.forEach(function (stage) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            stage.classList.toggle('is-visible', entry.isIntersecting);
          });
        },
        { threshold: 0.35 }
      );

      observer.observe(stage);
    });
  }

  var PROOF_ARROW_SVG_NS = 'http://www.w3.org/2000/svg';
  var PROOF_ARROWS_PER_LANE = 3;
  var PROOF_ARROW_POINTS = '10,0 -6,-5 -6,5';

  function clampNumber(value, min, max, fallback) {
    var num = Number.parseFloat(value);
    if (!Number.isFinite(num)) return fallback;
    return Math.min(max, Math.max(min, num));
  }

  function initEleventProofAirflowArrows(section) {
    if (!section) return;

    var hosts = section.querySelectorAll('[data-elevent-proof-arrows]');
    if (!hosts.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    // Merchant size % is designed around ~desktop media width; taper on narrow viewports.
    var PROOF_ARROW_REF_WIDTH = 900;

    hosts.forEach(function (host) {
      var stage = host.closest('.elevent-proof__media-stage') || host.parentElement;
      var mediaImg = stage ? stage.querySelector('img') : null;
      var lanes = Math.round(clampNumber(host.dataset.lanes, 1, 8, 5));
      var durationSec = clampNumber(host.dataset.speed, 1, 20, 4);
      var durationMs = durationSec * 1000;
      var arrowSizePct = clampNumber(host.dataset.arrowSize, 40, 150, 80);
      var arrowScaleBase = arrowSizePct / 100;
      var aX = clampNumber(host.dataset.aX, 0, 100, 28);
      var aY = clampNumber(host.dataset.aY, 0, 100, 68);
      var bX = clampNumber(host.dataset.bX, 0, 100, 78);
      var bY = clampNumber(host.dataset.bY, 0, 100, 68);
      var laneSpread = clampNumber(host.dataset.laneSpread, 0, 12, 4);
      var color = (host.dataset.color || '#e34f39').trim() || '#e34f39';
      var opacity = clampNumber(host.dataset.opacity, 20, 100, 85) / 100;

      host.style.setProperty('--proof-airflow-arrow-color', color);
      host.style.setProperty('--proof-airflow-arrow-opacity', String(opacity));

      var svg = document.createElementNS(PROOF_ARROW_SVG_NS, 'svg');
      svg.setAttribute('class', 'elevent-proof__media-arrows-svg');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.setAttribute('preserveAspectRatio', 'none');
      host.appendChild(svg);

      var tracksLayer = document.createElementNS(PROOF_ARROW_SVG_NS, 'g');
      tracksLayer.setAttribute('data-elevent-proof-arrow-tracks', '');
      svg.appendChild(tracksLayer);

      var arrowsLayer = document.createElementNS(PROOF_ARROW_SVG_NS, 'g');
      arrowsLayer.setAttribute('data-elevent-proof-arrow-markers', '');
      svg.appendChild(arrowsLayer);

      var controller = {
        tracks: [],
        rafId: null,
        visible: false,
        inView: false,
        startedAt: 0,
        stopped: false,
        width: 0,
        height: 0,
      };

      host._eleventProofArrows = controller;

      function createArrowMarker() {
        var arrow = document.createElementNS(PROOF_ARROW_SVG_NS, 'polygon');
        arrow.setAttribute('points', PROOF_ARROW_POINTS);
        arrow.setAttribute('class', 'elevent-proof__media-arrow');
        return arrow;
      }

      function readHostSize() {
        var width = host.clientWidth;
        var height = host.clientHeight;
        if ((!width || !height) && stage) {
          width = stage.clientWidth;
          height = stage.clientHeight;
        }
        if ((!width || !height) && mediaImg) {
          width = mediaImg.clientWidth;
          height = mediaImg.clientHeight;
        }
        return { width: width, height: height };
      }

      function responsiveArrowScale(width) {
        var factor = Math.min(1, Math.max(0.52, width / PROOF_ARROW_REF_WIDTH));
        return arrowScaleBase * factor;
      }

      function placeArrow(track, arrow, progress) {
        var distance = ((progress + arrow.offset) % 1) * track.length;
        var point = track.path.getPointAtLength(distance);
        var delta = Math.max(1, Math.min(8, track.length * 0.01));
        var ahead = track.path.getPointAtLength(Math.min(track.length, distance + delta));
        var angle = (Math.atan2(ahead.y - point.y, ahead.x - point.x) * 180) / Math.PI;
        var scale = track.arrowScale || 1;
        arrow.el.setAttribute(
          'transform',
          'translate(' + point.x + ' ' + point.y + ') rotate(' + angle + ') scale(' + scale + ')'
        );
      }

      function placeAll(progress) {
        controller.tracks.forEach(function (track) {
          track.arrows.forEach(function (arrow) {
            placeArrow(track, arrow, progress);
          });
        });
      }

      function rebuildTracks() {
        var size = readHostSize();
        var width = size.width;
        var height = size.height;
        if (!width || !height) return false;

        controller.width = width;
        controller.height = height;
        svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);

        while (tracksLayer.firstChild) tracksLayer.removeChild(tracksLayer.firstChild);
        while (arrowsLayer.firstChild) arrowsLayer.removeChild(arrowsLayer.firstChild);
        controller.tracks = [];

        var startX = (aX / 100) * width;
        var startY = (aY / 100) * height;
        var endX = (bX / 100) * width;
        var endY = (bY / 100) * height;
        // Honor merchant lane spread as % of media height (including 0 / sub-1%).
        var spreadPx = (laneSpread / 100) * height;
        var half = (lanes - 1) / 2;
        var scale = responsiveArrowScale(width);

        for (var laneIndex = 0; laneIndex < lanes; laneIndex += 1) {
          var offsetY = (laneIndex - half) * spreadPx;
          var path = document.createElementNS(PROOF_ARROW_SVG_NS, 'path');
          path.setAttribute(
            'd',
            'M ' + startX + ' ' + (startY + offsetY) + ' L ' + endX + ' ' + (endY + offsetY)
          );
          path.setAttribute('fill', 'none');
          path.setAttribute('stroke', 'none');
          tracksLayer.appendChild(path);

          var length = 0;
          try {
            length = path.getTotalLength();
          } catch (error) {
            length = 0;
          }
          if (!Number.isFinite(length) || length < 8) continue;

          var arrows = [];
          for (var i = 0; i < PROOF_ARROWS_PER_LANE; i += 1) {
            var arrow = createArrowMarker();
            arrowsLayer.appendChild(arrow);
            arrows.push({
              el: arrow,
              offset: (i / PROOF_ARROWS_PER_LANE + (laneIndex % 3) * 0.07) % 1,
            });
          }

          controller.tracks.push({
            path: path,
            length: length,
            durationMs: durationMs,
            arrowScale: scale,
            arrows: arrows,
          });
        }

        placeAll(0);
        return controller.tracks.length > 0;
      }

      function tick(now) {
        if (controller.stopped || !controller.visible) {
          controller.rafId = null;
          return;
        }

        if (!controller.startedAt) controller.startedAt = now;
        var elapsed = now - controller.startedAt;

        controller.tracks.forEach(function (track) {
          var progress = (elapsed % track.durationMs) / track.durationMs;
          track.arrows.forEach(function (arrow) {
            placeArrow(track, arrow, progress);
          });
        });

        controller.rafId = window.requestAnimationFrame(tick);
      }

      function start() {
        if (controller.stopped || controller.rafId) return;
        if (!controller.tracks.length && !rebuildTracks()) return;
        controller.visible = true;
        controller.startedAt = 0;
        controller.rafId = window.requestAnimationFrame(tick);
      }

      function stop() {
        controller.visible = false;
        if (controller.rafId) {
          window.cancelAnimationFrame(controller.rafId);
          controller.rafId = null;
        }
      }

      function refreshAndMaybeStart() {
        stop();
        rebuildTracks();
        if (controller.inView) start();
      }

      rebuildTracks();

      var resizeTimer = null;
      var resizeObserver =
        typeof ResizeObserver !== 'undefined'
          ? new ResizeObserver(function () {
              window.clearTimeout(resizeTimer);
              resizeTimer = window.setTimeout(refreshAndMaybeStart, 80);
            })
          : null;

      if (resizeObserver) {
        resizeObserver.observe(host);
        if (stage && stage !== host) resizeObserver.observe(stage);
      }

      if (mediaImg) {
        if (!mediaImg.complete) {
          mediaImg.addEventListener('load', refreshAndMaybeStart, { once: true });
        }
      }

      var visibilityObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            controller.inView = entry.isIntersecting;
            if (entry.isIntersecting) {
              if (!controller.tracks.length) rebuildTracks();
              start();
            } else {
              stop();
            }
          });
        },
        { threshold: 0.01, rootMargin: '40px 0px' }
      );

      visibilityObserver.observe(stage || host);
    });
  }


  function initEleventAlignmentPaths(section) {
    if (!section) return;

    var hosts = section.querySelectorAll('[data-elevent-alignment-paths]');
    if (!hosts.length) return;

    var SVG_NS = 'http://www.w3.org/2000/svg';
    var MIN_PATH_LENGTH = 24;
    var ARROW_POINTS = '12,0 -7,-6.5 -7,6.5';
    var ARROW_BASE_OPACITY = 0.92;
    var maskSeq = 0;

    function clamp(value, min, max, fallback) {
      var num = Number.parseFloat(value);
      if (!Number.isFinite(num)) return fallback;
      return Math.min(max, Math.max(min, num));
    }

    function parseColorChannels(value) {
      if (!value || value === 'none' || value === 'transparent') return null;
      var normalized = String(value).trim().toLowerCase();
      if (normalized.startsWith('#')) {
        var hex = normalized.slice(1);
        if (hex.length === 3) {
          hex = hex
            .split('')
            .map(function (c) {
              return c + c;
            })
            .join('');
        }
        if (hex.length !== 6) return null;
        return {
          r: parseInt(hex.slice(0, 2), 16),
          g: parseInt(hex.slice(2, 4), 16),
          b: parseInt(hex.slice(4, 6), 16),
        };
      }
      var rgbMatch = normalized.match(/rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)/);
      if (rgbMatch) {
        return { r: Number(rgbMatch[1]), g: Number(rgbMatch[2]), b: Number(rgbMatch[3]) };
      }
      return null;
    }

    function isGreenish(color) {
      var channels = parseColorChannels(color);
      if (!channels) return false;
      return channels.g > 90 && channels.g > channels.r * 1.15 && channels.g > channels.b * 1.1;
    }

    function isDarkRouteColor(color) {
      var channels = parseColorChannels(color);
      if (!channels) return false;
      var luminance = 0.2126 * channels.r + 0.7152 * channels.g + 0.0722 * channels.b;
      return luminance < 90;
    }

    function readPaint(el, attrName) {
      var direct = el.getAttribute(attrName);
      if (direct && direct !== 'inherit') return direct;
      var styleAttr = el.getAttribute('style') || '';
      var styleMatch = styleAttr.match(new RegExp(attrName + '\\s*:\\s*([^;]+)', 'i'));
      if (styleMatch) return styleMatch[1].trim();
      return direct || '';
    }

    function isAnimatablePath(pathEl) {
      var length = 0;
      try {
        length = pathEl.getTotalLength();
      } catch (error) {
        return false;
      }
      if (!Number.isFinite(length) || length < MIN_PATH_LENGTH) return false;

      var fill = readPaint(pathEl, 'fill');
      var stroke = readPaint(pathEl, 'stroke');
      var strokeWidth = Number.parseFloat(pathEl.getAttribute('stroke-width') || '1');

      if (isGreenish(fill) && (!stroke || stroke === 'none' || isGreenish(stroke))) return false;
      if (isGreenish(stroke) && strokeWidth >= 4) return false;
      if (stroke && stroke !== 'none') {
        if (isDarkRouteColor(stroke) || !isGreenish(stroke)) return true;
        return false;
      }
      if (fill && fill !== 'none' && isDarkRouteColor(fill) && !isGreenish(fill)) return true;
      return length >= 80;
    }

    function extractSvgMarkup(rawText) {
      if (!rawText || rawText.indexOf('<svg') === -1) return null;
      var doc = new DOMParser().parseFromString(rawText.trim(), 'image/svg+xml');
      var parsedSvg = doc.querySelector('svg');
      if (!parsedSvg || doc.querySelector('parsererror')) return null;
      return parsedSvg;
    }

    function normalizeInlineSvg(svg) {
      svg.removeAttribute('width');
      svg.removeAttribute('height');
      svg.setAttribute('preserveAspectRatio', svg.getAttribute('preserveAspectRatio') || 'xMidYMid meet');
      svg.style.width = '100%';
      svg.style.height = 'auto';
      svg.style.display = 'block';
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      return svg;
    }

    function ensureDefs(svg) {
      var defs = svg.querySelector('defs');
      if (!defs) {
        defs = document.createElementNS(SVG_NS, 'defs');
        svg.insertBefore(defs, svg.firstChild);
      }
      return defs;
    }

    function applyEndFadeMask(pathEl, fadeZone) {
      if (!fadeZone || fadeZone <= 0) return;
      var svg = pathEl.ownerSVGElement;
      if (!svg) return;
      var length = 0;
      try {
        length = pathEl.getTotalLength();
      } catch (error) {
        return;
      }
      if (!Number.isFinite(length) || length < MIN_PATH_LENGTH) return;

      var start = pathEl.getPointAtLength(0);
      var end = pathEl.getPointAtLength(length);
      var defs = ensureDefs(svg);
      maskSeq += 1;
      var gradId = 'elevent-align-fade-grad-' + maskSeq;
      var maskId = 'elevent-align-fade-mask-' + maskSeq;

      var gradient = document.createElementNS(SVG_NS, 'linearGradient');
      gradient.setAttribute('id', gradId);
      gradient.setAttribute('gradientUnits', 'userSpaceOnUse');
      gradient.setAttribute('x1', String(start.x));
      gradient.setAttribute('y1', String(start.y));
      gradient.setAttribute('x2', String(end.x));
      gradient.setAttribute('y2', String(end.y));

      function addStop(offset, color) {
        var stop = document.createElementNS(SVG_NS, 'stop');
        stop.setAttribute('offset', offset);
        stop.setAttribute('stop-color', color);
        gradient.appendChild(stop);
      }

      addStop('0%', '#ffffff');
      addStop(Math.round((1 - fadeZone) * 100) + '%', '#ffffff');
      addStop('100%', '#000000');

      var mask = document.createElementNS(SVG_NS, 'mask');
      mask.setAttribute('id', maskId);
      mask.setAttribute('maskUnits', 'userSpaceOnUse');
      var maskRect = document.createElementNS(SVG_NS, 'rect');
      var bbox = null;
      try {
        bbox = pathEl.getBBox();
      } catch (error) {
        bbox = null;
      }
      var pad = 24;
      if (bbox && Number.isFinite(bbox.width)) {
        maskRect.setAttribute('x', String(bbox.x - pad));
        maskRect.setAttribute('y', String(bbox.y - pad));
        maskRect.setAttribute('width', String(Math.max(1, bbox.width + pad * 2)));
        maskRect.setAttribute('height', String(Math.max(1, bbox.height + pad * 2)));
      } else {
        maskRect.setAttribute('x', '0');
        maskRect.setAttribute('y', '0');
        maskRect.setAttribute('width', '100%');
        maskRect.setAttribute('height', '100%');
      }
      maskRect.setAttribute('fill', 'url(#' + gradId + ')');
      mask.appendChild(maskRect);
      defs.appendChild(gradient);
      defs.appendChild(mask);
      pathEl.setAttribute('mask', 'url(#' + maskId + ')');
    }

    function fetchAndInlineSvg(layer) {
      if (layer.querySelector('svg[data-elevent-inlined]')) {
        return Promise.resolve(layer.querySelector('svg[data-elevent-inlined]'));
      }

      var src = layer.dataset.svgSrc || (layer.querySelector('img') && (layer.querySelector('img').currentSrc || layer.querySelector('img').src));
      if (!src) return Promise.resolve(null);

      return fetch(src, { mode: 'cors', credentials: 'omit' })
        .then(function (response) {
          if (!response.ok) throw new Error('SVG fetch failed');
          return response.text();
        })
        .then(function (raw) {
          var parsed = extractSvgMarkup(raw);
          if (!parsed) throw new Error('Invalid SVG');
          var svg = normalizeInlineSvg(parsed.cloneNode(true));
          svg.setAttribute('data-elevent-inlined', 'true');
          var img = layer.querySelector('img');
          if (img) img.remove();
          layer.appendChild(svg);
          return svg;
        })
        .catch(function (error) {
          console.warn('[elevent-proof] Could not inline alignment path SVG:', error);
          return null;
        });
    }

    hosts.forEach(function (host) {
      var arrowsEnabled = host.dataset.arrowsEnabled !== 'false';
      var hideStrokes = host.dataset.hideStrokes === 'true';
      var durationMs = Math.max(2000, clamp(host.dataset.arrowsSpeed, 2, 12, 4) * 1000);
      var arrowScale = Math.max(0.3, Math.min(1.4, clamp(host.dataset.arrowsSize, 30, 120, 70) / 100));
      var arrowsPerPath = Math.round(clamp(host.dataset.arrowsCount, 2, 8, 3));
      var fadeEnd = clamp(host.dataset.fadeEnd, 0, 40, 22) / 100;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var shouldAnimate = arrowsEnabled && !reducedMotion;

      var controller = {
        tracks: [],
        rafId: null,
        visible: false,
        startedAt: 0,
        stopped: false,
      };
      host._eleventAlignmentPaths = controller;

      function createArrow() {
        var arrow = document.createElementNS(SVG_NS, 'polygon');
        arrow.setAttribute('points', ARROW_POINTS);
        arrow.setAttribute('class', 'elevent-proof__alignment-path-arrow');
        return arrow;
      }

      function placeArrow(track, arrow, progress) {
        var t = (progress + arrow.offset) % 1;
        var distance = t * track.length;
        var point = track.path.getPointAtLength(distance);
        var delta = Math.max(1, Math.min(8, track.length * 0.01));
        var ahead = track.path.getPointAtLength(Math.min(track.length, distance + delta));
        var angle = (Math.atan2(ahead.y - point.y, ahead.x - point.x) * 180) / Math.PI;
        var opacity = ARROW_BASE_OPACITY;
        if (fadeEnd > 0 && t >= 1 - fadeEnd) {
          opacity *= Math.max(0, (1 - t) / fadeEnd);
        }
        arrow.el.setAttribute(
          'transform',
          'translate(' + point.x + ' ' + point.y + ') rotate(' + angle + ') scale(' + track.arrowScale + ')'
        );
        arrow.el.style.opacity = String(opacity);
      }

      function tick(now) {
        if (controller.stopped || !controller.visible) {
          controller.rafId = null;
          return;
        }
        if (!controller.startedAt) controller.startedAt = now;
        var elapsed = now - controller.startedAt;
        controller.tracks.forEach(function (track) {
          var progress = (elapsed % track.durationMs) / track.durationMs;
          track.arrows.forEach(function (arrow) {
            placeArrow(track, arrow, progress);
          });
        });
        controller.rafId = requestAnimationFrame(tick);
      }

      function start() {
        if (controller.stopped || controller.rafId || !controller.tracks.length) return;
        controller.visible = true;
        controller.startedAt = 0;
        controller.rafId = requestAnimationFrame(tick);
      }

      function stop() {
        controller.visible = false;
        if (controller.rafId) {
          cancelAnimationFrame(controller.rafId);
          controller.rafId = null;
        }
      }

      fetchAndInlineSvg(host).then(function (svg) {
        if (!svg) return;
        var paths = Array.prototype.slice.call(svg.querySelectorAll('path'));
        var targets = paths.filter(isAnimatablePath);
        if (!targets.length) {
          targets = paths.filter(function (pathEl) {
            try {
              return pathEl.getTotalLength() >= MIN_PATH_LENGTH;
            } catch (error) {
              return false;
            }
          });
        }

        var arrowLayer = svg.querySelector('[data-elevent-alignment-path-arrows]');
        if (!arrowLayer) {
          arrowLayer = document.createElementNS(SVG_NS, 'g');
          arrowLayer.setAttribute('data-elevent-alignment-path-arrows', '');
          svg.appendChild(arrowLayer);
        }

        targets.forEach(function (pathEl, pathIndex) {
          pathEl.classList.add('elevent-proof__alignment-route');
          if (hideStrokes) pathEl.classList.add('is-stroke-hidden');
          applyEndFadeMask(pathEl, fadeEnd);

          if (!shouldAnimate) return;

          var length = 0;
          try {
            length = pathEl.getTotalLength();
          } catch (error) {
            return;
          }
          if (!Number.isFinite(length) || length < MIN_PATH_LENGTH) return;

          var arrows = [];
          for (var i = 0; i < arrowsPerPath; i += 1) {
            var arrowEl = createArrow();
            arrowLayer.appendChild(arrowEl);
            arrows.push({
              el: arrowEl,
              offset: (i / arrowsPerPath + (pathIndex % 3) * 0.07) % 1,
            });
          }

          controller.tracks.push({
            path: pathEl,
            length: length,
            durationMs: durationMs,
            arrowScale: arrowScale,
            arrows: arrows,
          });
        });

        if (!shouldAnimate || !controller.tracks.length) return;

        controller.tracks.forEach(function (track) {
          track.arrows.forEach(function (arrow) {
            placeArrow(track, arrow, 0);
          });
        });

        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) start();
              else stop();
            });
          },
          { rootMargin: '80px 0px', threshold: 0.05 }
        );
        observer.observe(host);
        controller.observer = observer;

        var rect = host.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) start();
      });
    });
  }

  function boot() {
    var sections = document.querySelectorAll('.elevent-proof');
    sections.forEach(function (section) {
      initEleventProofCounters(section);
      initEleventProofHotspots(section);
      initEleventInstallVideos(section);
      initEleventAlignmentStage(section);
      initEleventProofAirflowArrows(section);
      initEleventAlignmentPaths(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
